// Simple gate to defer SignalR connection until the app is fully ready
let allowed = false;
const listeners: Array<() => void> = [];

export function isSignalRAllowed() {
  return allowed;
}

export function onSignalRAllowed(cb: () => void) {
  if (allowed) {
    cb();
  } else {
    listeners.push(cb);
  }
}

export function allowSignalR() {
  if (allowed) return;
  allowed = true;
  while (listeners.length) {
    const cb = listeners.shift();
    try {
      if (cb) {
        void cb();
      }
    } catch {
      // ignore
    }
  }
}

// Helper: schedule based on network conditions, mobile detection, and app lifecycle
export function scheduleAllowSignalR(delayFast = 2000, delaySlow = 5000, delayMobile = 8000) {
  const isCellularOrSaveData = () => {
    type NetInfo =
      | { effectiveType?: string; type?: string; saveData?: boolean }
      | undefined;
    const nav = navigator as unknown as {
      connection?: NetInfo;
      mozConnection?: NetInfo;
      webkitConnection?: NetInfo;
    };
    const c = nav?.connection || nav?.mozConnection || nav?.webkitConnection;
    const eff: string = c?.effectiveType || "";
    const slow = /(slow-2g|2g|3g)/i.test(eff);
    const cell = /cellular/i.test(c?.type || "");
    return Boolean(c?.saveData || slow || cell);
  };

  const isMobileDevice = () => {
    if (typeof window === "undefined") return false;
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileRegex =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    const screenWidth = window.innerWidth;
    return mobileRegex.test(userAgent) || screenWidth <= 768;
  };

  const isMobileEnvironment = isMobileDevice() || isCellularOrSaveData();
  
  // En móvil, diferir SignalR hasta el final final (8 segundos por defecto)
  const delay = isMobileEnvironment ? delayMobile : (isCellularOrSaveData() ? delaySlow : delayFast);

  // Prefer enabling after window 'load' + idle period
  const enable = () => allowSignalR();
  const w = window as Window & {
    requestIdleCallback?: (
      cb: IdleRequestCallback,
      opts?: IdleRequestOptions
    ) => number;
  };
  const afterIdle = () => {
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(() => setTimeout(enable, delay));
    } else {
      setTimeout(enable, delay);
    }
  };

  if (document.readyState === "complete") {
    afterIdle();
  } else {
    window.addEventListener("load", afterIdle, { once: true });
  }
}
